function SelectInput({ label, options, value, onChange }) {
  return (
    <div className="flex flex-col gap-2">
      <label className="text-gray-600 font-medium">{label}</label>
      <select
        value={value}
        onChange={onChange}
        className="
          w-full px-4 py-2 border border-gray-300 rounded-lg 
          focus:outline-none focus:ring-2 focus:ring-primary 
          focus:border-transparent transition-all text-gray-700
        "
      >
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
            
          </option>
        ))}
      </select>
    </div>
  );
}

export default SelectInput;
